import ComplianceClient from "@common/api/ComplianceClient";
import useComplianceView from "./useComplianceView";
import { handleError } from "@common/components/helpers/error";
import useLogin from "@common/components/hooks/useLogin";
import { useCallback } from "react";
import { handleDownload } from "@common/components/helpers/downloads";
import useOrganisationTreeSelections from "./useOrganisationTreeSelections.js";

export default function useEventDetailsGrid() {
  const {
    allNames,
    filters,
    showDateRangeModal,
    isLoading,
    eventsGrid,
    operator,
    eventsGridLoading,
    setViewData,
    hasSelection,
    eventsGridActiveRow,
  } = useComplianceView();

  const [{ isInReadMode }, dispatchLogin] = useLogin();
  const siteIds = useOrganisationTreeSelections("complianceFilters");

  const onRowClick = useCallback(
    (eventsGridActiveRow) => {
      setViewData({ eventsGridActiveRow });
      dispatchLogin({ site: eventsGridActiveRow?.site, isInReadMode: true });
    },
    [setViewData],
  );

  const onRefresh = (
    returnCsv = false,
    keepActiveRow = true,
    name = null,
    resetPage = false,
  ) => {
    const { startDate, endDate } = filters;
    if (!hasSelection || !operator || (!startDate && !endDate)) {
      return;
    }

    const onReturnGrid = ({ statusCounts, data, totalRecords }) => {
      setViewData({
        totalRecords,
        statusCounts,
        eventsGrid: data,
        eventsGridActiveRow: keepActiveRow
          ? data.find((x) => x.id === eventsGridActiveRow?.id)
          : null,
        ...(resetPage ? { filters: { ...filters, activePage: 1 } } : {}),
      });
    };

    const onReturnCsv = (response) => handleDownload(response);

    setViewData({
      eventsGridLoading: true,
    });
    ComplianceClient.getEventDetails({
      ...filters,
      siteIds,
      allNames: name ?? allNames,
      returnCsv,
    })
      .then(returnCsv ? onReturnCsv : onReturnGrid, (error) => {
        handleError(error);
      })
      .finally(() => setViewData({ eventsGridLoading: false }));
  };

  return {
    filters,
    isLoading,
    showDateRangeModal,
    activeRow: eventsGridActiveRow,
    grid: eventsGrid,
    gridLoading: eventsGridLoading,
    onRefresh,
    onRowClick,
    setViewData,
  };
}
